// Authorize
import AuthorizeRequest from './authorize/Request';
// Camera
import CameraChangeLens from './camera/ChangeLens';
import CameraGimbal from './camera/Gimbal';
import CameraLiveView from './camera/LiveView';
// Flight Control
import FlightControlBrake from './flight-control/Brake';
import FlightControlGoto from './flight-control/Goto';
import FlightControlReturnHome from './flight-control/ReturnHome';
import FlightControlStickControl from './flight-control/StickControl';
import FlightControlTakeoff from './flight-control/Takeoff';
import FlightControlTakeoffSimulation from './flight-control/TakeoffSimulation';
// Mission
import MissionClear from './mission/Clear';
import MissionLoad from './mission/Load';
import MissionPause from './mission/Pause';
import MissionResume from './mission/Resume';
import MissionStart from './mission/Start';
import MissionUpload from './mission/Upload';
import MissionUploadSimulation from './mission/UploadSimulation';
// Remote Debug
import RemoteDebugAircraftCharge from './remote-debug/AircraftCharge';
import RemoteDebugAircraftPower from './remote-debug/AircraftPower';
import RemoteDebugDebugMode from './remote-debug/DebugMode';
import RemoteDebugDockCanopy from './remote-debug/DockCanopy';
import RemoteDebugDockRestart from './remote-debug/DockRestart';

export {
  // Authorize
  AuthorizeRequest,
  // Camera
  CameraChangeLens,
  CameraGimbal,
  CameraLiveView,
  // Flight Control
  FlightControlBrake,
  FlightControlGoto,
  FlightControlReturnHome,
  FlightControlStickControl,
  FlightControlTakeoff,
  FlightControlTakeoffSimulation,
  // Mission
  MissionClear,
  MissionLoad,
  MissionPause,
  MissionResume,
  MissionStart,
  MissionUpload,
  MissionUploadSimulation,
  // Remote Debug
  RemoteDebugAircraftCharge,
  RemoteDebugAircraftPower,
  RemoteDebugDebugMode,
  RemoteDebugDockCanopy,
  RemoteDebugDockRestart,
};

const commands = [
  // Authorize
  AuthorizeRequest,
  // Camera
  CameraChangeLens,
  CameraGimbal,
  CameraLiveView,
  // Flight Control
  FlightControlBrake,
  FlightControlGoto,
  FlightControlReturnHome,
  FlightControlStickControl,
  FlightControlTakeoff,
  FlightControlTakeoffSimulation,
  // Mission
  MissionClear,
  MissionLoad,
  MissionPause,
  MissionResume,
  MissionStart,
  MissionUpload,
  MissionUploadSimulation,
  // Remote Debug
  RemoteDebugAircraftCharge,
  RemoteDebugAircraftPower,
  RemoteDebugDebugMode,
  RemoteDebugDockCanopy,
  RemoteDebugDockRestart,
];

export default commands;
